import React, { useState } from 'react';
import * as config from '../../config.js';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectColor,
  toggleColor,
  setLastUrl,
  clearLastUrl
} from './colorSlice';
import {
  toggleColorToFormData,
  getOutterline,
} from '../formData/formDataSlice';
import {
  Checkbox,
  Tabs,
  Tab
} from '@mui/material';

const tabCount = 10;
let tabData = [];
for(let i=0; i<tabCount; i++){
  tabData.push({
    key:i,
    id:i
  })
}
export function Color(props) {
  const dispatch = useDispatch();
  const [tabList, setTabList] = useState(tabData);
  const [tabvalue, setTabValue] = React.useState(0);

  const colors = useSelector(selectColor);
  const outterline = useSelector(getOutterline);

  const toggleLayout = function(color){
    if(outterline && (color.groupIdx != null && parseInt(color.groupIdx) != parseInt(tabvalue))){
      return;
    }
    dispatch(toggleColor({
      colorId : color.id,
      groupIdx : parseInt(tabvalue)
    }))

    dispatch(toggleColorToFormData({
      colorId : color.id,
      groupIdx : parseInt(tabvalue)
    }))
  } 

  const tabHandleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMouseEnter = (color, e) =>{
    if(e.target.className == 'image_wrap'){
      for(let i=0; i < e.target.parentElement.children.length; i++){
        e.target.parentElement.children[i].style.backgroundColor = "initial";
        e.target.parentElement.children[i].style.border = "1px solid #fff";
      }
      e.target.style.backgroundColor = "rgb("+color.color.join()+")";
      e.target.style.border = "1px solid #000";
    }
    dispatch(setLastUrl(color.id))
  }
  const handleMouseLeave = (color, e) =>{
    e.target.style.backgroundColor = "initial";
    e.target.style.border = "1px solid #fff";
    dispatch(clearLastUrl(""))
  }
  // for test (addTab)
  const addTab = () => {
    setTabList([...tabList, {
      key:tabList.length,
      id:tabList.length,
    }])
  }
  const divWrapStyle ={
    textAlign: "center",
    width: "100%",
    overflow : "scroll",
    height: 'calc(100vh - 362px)',
    backgroundColor: "rgb(250, 250, 250)"
  };
  const divStyle ={
    display:"inline-block",
    // width:"30%",
    padding:"5px",
    margin:"10px 1%",
    border: "1px solid #fff",
    float:'center',
    boxSizing: "content-box",
  }
  return (
    <div>
      <Tabs
        value={tabvalue}
        onChange={tabHandleChange}
        variant="scrollable"
        scrollButtons
        TabIndicatorProps={{ style: { backgroundColor: config.DABEEO_COLOR, color:config.DABEEO_COLOR } }}
        sx={{ width: '100%', visibility: outterline ? "show" : "hidden" }}
      > 
        {
          tabList.map((tab)=>(
            <Tab
                disabled={ !props.disabledForm && outterline ? false : true}
                key={tab.key}
                value={tab.id}
                label={"Colorset "+tab.id}
                wrapped
                style={{ color:config.DABEEO_COLOR }}
            />
          ))
        }
      </Tabs>

      <div style={ divWrapStyle }>
        {colors.map(color => (
          <div className="image_wrap" style={ divStyle } key={color.id} onClick={() => toggleLayout(color)} onMouseEnter={(e) => handleMouseEnter(color, e)} onMouseLeave={(e) => handleMouseLeave(color, e)}>
            <img style={{ display:"inline-block", width:"100%" }} src={color["preview-image-url"]} />
            <div style={{ display:"inline-block", border:"1px solid rgb(0,0,0)", width:"30px", height:"30px", backgroundColor: "rgb("+color.color.join()+")" }}></div>
            <Checkbox checked={ color.checked ? true : false } disabled={ color.groupIdx == tabvalue ? false : outterline ? true : false} >
            </Checkbox>
            <img src={color.url} />
          </div> 
        ))}
      </div>
    </div>
  );
}
